import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../../get-base-url';
import { useParams } from 'react-router-dom';
import RegisterCohabitationNotificationShared from 'shell/components/shared/research-notifications/research-cohabitation/detail';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface RegisterCohabitationNotificationCivilStatusSharedProps {
  scope?: string;
  isOther?: boolean;
  items?: BreadcrumbItem[];
}

const RegisterCohabitationNotificationCivilStatusShared = ({
  scope,
  isOther,
  items,
}: RegisterCohabitationNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);
  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope, idCat]);

  const goBackUrl: string = useMemo(() => {
    return `${baseUrl}/modifica/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${baseUrl}/visualizza/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  return (
    <Fragment>
      <RegisterCohabitationNotificationShared
        goBackUrl={goBackUrl}
        items={items}
        isOther={isOther}
        goBackUrlDetail={goBackUrlDetail}
      />
    </Fragment>
  );
};

RegisterCohabitationNotificationCivilStatusShared.displayName =
  'Research Cohabitation Notifications Detail Page component';

export default RegisterCohabitationNotificationCivilStatusShared;
